import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { IssueType } from '../IssueTypesContext/types'
import { CIMSPage } from '@cims-online/shared'

export function useExpand(): ExpandOptions<IssueType> {
  return {
    expandable: ({ issues }) => !!issues.length,
    render: ({ id, issues }) => ({
      additionalInfo: [
        {
          type: 'deepLinks',
          label: 'Issues',
          showMore: { key: id },
          links: issues.map(({ deleted, formattedNumber, id }) => ({
            page: CIMSPage.IssueTracker,
            label: formattedNumber,
            deep: { recordId: id, deleted },
          })),
        },
      ],
    }),
  }
}
